import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import userStore from './userStore'
import questStore from './questStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    userStore,
    questStore,
  },
  plugins: [createPersistedState({key: 'v2'})]
})
